module.exports = __webpack_public_path__ + "img/FTHS__FantasyHammer.a66f8adf.png";